<template>
    <div>
        <div class="top-banner">
            <div class="top-banner-title">人脸认证</div>
            <div class="top-banner-subtitle">FACE AUTHENTICATION</div>
            <div class="top-banner-detail">基于人脸识别的KYC验证服务，确保当事人是“真人和本人”</div>
            <div class="top-banner-try" @click="queryToTry">马上试用</div>
            <div class="top-banner-buy" @click="queryToBuy">购买咨询</div>
        </div>
        <div class="desc-content">
            <div class="face-auth-desc">具备活体认证、人像认证、人脸对比、人脸检索等能力</div>
            <div class="face-auth-prompt">支持多种场景，高安全保障，毫秒级人脸识别，高效率低风险，助力用户数字化转型</div>

            <ul class="face-auth-flex-ul">
                <li class="face-auth-type-item">
                    <img src="@/assets/img/product/face_auth_type_1.png"/>
                    <div class="face-auth-type-item-detail-title">
                        <label>活体认证</label>
                        <div class="bottom_hint"></div>
                        <div class="face-auth-type-item-prompt">通过提示信息，使用人脸关键点定位和人脸追踪等技术，精准判断用户的真实性，有效鉴别照片、视频、模型等欺骗行为</div>
                    </div>
                </li>
                <li class="face-auth-type-item">
                    <img src="@/assets/img/product/face_auth_type_2.png"/>
                    <div class="face-auth-type-item-detail-title">
                        <label>人像认证</label>
                        <div class="bottom_hint"></div>
                        <div class="face-auth-type-item-prompt">人像与身份证证件照进行比对，一次完成实名认证+本人认证，给出是与否的结果</div>
                    </div>
                </li>
                <li class="face-auth-type-item">
                    <img src="@/assets/img/product/face_auth_type_3.png"/>
                    <div class="face-auth-type-item-detail-title">
                        <label>人脸对比</label>
                        <div class="bottom_hint"></div>
                        <div class="face-auth-type-item-prompt">计算两张脸的相似程度，结合AI场景风控，给出是与否的结果</div>
                    </div>
                </li>
                <li class="face-auth-type-item">
                    <img src="@/assets/img/product/face_auth_type_4.png"/>
                    <div class="face-auth-type-item-detail-title">
                        <label>人脸搜索</label>
                        <div class="bottom_hint"></div>
                        <div class="face-auth-type-item-prompt">针对一个新的人脸，结合AI场景风控，给出是与否的结果</div>
                    </div>
                </li>
            </ul>

            <div>
                <div class="face-auth-desc-item">产品优势</div>
                <div class="bottom_hint"></div>
                <ul class="face-auth-flex-ul">
                    <li class="face-auth-desc-advantage-item">
                        <img src="@/assets/img/product/face_auth_advantage_1.png"/>
                        <div class="face-auth-desc-advantage-item-detail-title">
                            <label>安全高效</label>
                            <div>领先完备的安全机制</div>
                        </div>
                    </li>
                    <li class="face-auth-desc-advantage-item">
                        <img src="@/assets/img/product/face_auth_advantage_2.png"/>
                        <div class="face-auth-desc-advantage-item-detail-title">
                            <label>方便快捷</label>
                            <div>多种场景毫秒级识别</div>
                        </div>
                    </li>
                    <li class="face-auth-desc-advantage-item">
                        <img src="@/assets/img/product/face_auth_advantage_3.png"/>
                        <div class="face-auth-desc-advantage-item-detail-title">
                            <label>价格优惠</label>
                            <div>搭配人脸支付，免费试用</div>
                        </div>
                    </li>
                </ul>
                <div class="face-auth-desc-item">助力场景</div>
                <div class="bottom_hint"></div>
                <div class="face-auth-desc-scene margin-25">
                    <img class="face-auth-scene-img-left" src="@/assets/img/product/face_auth_scene_1.png"/>
                    <img class="face-auth-scene-img-right" src="@/assets/img/product/face_auth_scene_2.png"/>
                    <label class="face-auth-desc-scene-left">未成年防沉迷</label>
                    <label class="face-auth-desc-scene-right">人脸通行证</label>
                </div>
                <div class="face-auth-desc-scene margin-25">
                    <img class="face-auth-scene-img-left" src="@/assets/img/product/face_auth_scene_3.png"/>
                    <img class="face-auth-scene-img-right" src="@/assets/img/product/face_auth_scene_4.png"/>
                    <label class="face-auth-desc-scene-left">会员认证</label>
                    <label class="face-auth-desc-scene-right">账户开立</label>
                </div>
                <div class="face-auth-desc-item">方案流程</div>
                <div class="face-auth-process-subtitle">致力于AI研发投入，提供更智能产品</div>
                <div class="bottom_hint"></div>
                <img class="face-auth-process-img" src="@/assets/img/product/face_auth_process.png"/>

                <div class="face-auth-desc-item">接入方式</div>
                <div class="bottom_hint"></div>
                <img class="access-introduce-img" src="@/assets/img/product/face_pay_access.png"/>
            </div>
            <div class="face-auth-contact-us">
                <div class="face-auth-contact-us-prompt">这个智能时代，我们将成为您最可靠的伙伴</div>
                <div class="face-auth-contact-us-title" @click="queryToBuy">联系我们</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global from '../../components/Global.vue';
    export default {
        name: "Product",
        methods :{
            queryToTry: function () {
                //试用
                this.$router.push(Global.routes.aboutCooperation);
            },
            queryToBuy: function () {
                //购买
                this.$router.push(Global.routes.aboutCooperation);
            }
        }
    }
</script>

<style scoped>

    @import "../../assets/css/base.css";

    .margin-25 {
        margin-top: 25px;
    }

    .bottom_hint {
        width: 100px;
        height: 4px;
        margin: 16px auto auto;
        background: #4183D7;
    }

    .top-banner {
        position: relative;
        width: 100%;
        height: 360px;
        background: url("../../assets/img/product/face_auth_back_banner.png") no-repeat;
        background-size:cover;
    }

    .top-banner-title {
        position: absolute;
        left: 130px;
        top: 85px;
        font-size: 60px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }

    .top-banner-detail {
        position: absolute;
        left: 130px;
        top: 200px;
        font-size: 24px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
    }

    .top-banner-try {
        position: absolute;
        left: 130px;
        bottom: 39px;
        width: 160px;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        background: #4183D7;
        color: white;
        border-radius: 2px;
        text-align: center;
    }

    .top-banner-buy {
        position: absolute;
        left: 300px;
        bottom: 39px;
        width: 160px;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        background: white;
        color: #4183D7;
        border-radius: 2px;
        text-align: center;
    }
    .desc-content {
        text-align: center;
    }

    .face-auth-desc {
        padding-left: 80px;
        padding-right: 80px;
        margin-top: 70px;
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Light, PingFang SC;
        color: #3A404D;
    }
    .face-auth-prompt {
        margin-top: 11px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404D;
        line-height: 22px;
    }

    .face-auth-desc span {
        color: #3C3C3C;
        font-weight: bold;
    }

    .face-auth-desc-item {
        margin-top: 60px;
        margin-left: 80px;
        margin-right: 80px;
        padding-top: 70px;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        color: #000000;
        height: 56px;
        line-height: 56px;
        border-top: dotted #1968FC 1px;
    }

    .face-auth-flex-ul {
        display: flex;
        justify-content: center;
    }

    .face-auth-type-item {
        margin-top: 44px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 23%;
    }

    .face-auth-type-item img {
        width: auto;
        height: 120px;
        margin: 10px auto;
    }

    .face-auth-desc-advantage-item {
        margin-top: 60px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 30%;
    }

    .face-auth-type-item-detail-title label {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #3A404D;
        line-height: 40px;
        text-align: center;
    }

    .face-auth-type-item-prompt {
        margin-top: 20px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404D;
        line-height: 22px;
        text-align: left;
        padding-left: 30px;
        padding-right: 30px;
    }

    .face-auth-desc-advantage-item img {
        margin: auto;
        width: 300px;
        height: 225px;
    }


    .face-auth-desc-advantage-item-detail-title {
        text-align: center;
    }

    .face-auth-desc-advantage-item-detail-title div {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404D;
        line-height: 28px;
    }

    .face-auth-desc-advantage-item-detail-title label {
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
    }


    .face-auth-desc-scene {
        padding: 15px 80px;
        position: relative;
    }

    .face-auth-scene-img-left {
        width: 47%;
        max-width: 600px;
        min-width: 100px;
        margin-left: 3%;
    }

    .face-auth-scene-img-right {
        width: 47%;
        max-width: 600px;
        min-width: 100px;
        margin-right: 3%;
    }


    .face-auth-desc-scene-left {

        display: flex;
        align-items: center;
        justify-content: flex-end;

        position:absolute;
        width: 43%;
        top: 15px;
        bottom: 0;
        left: 0;
        padding-right: 7%;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 100;
        color: white;
    }

    .face-auth-desc-scene-right {

        display: flex;
        align-items: center;
        justify-content: flex-start;

        position:absolute;
        width: 43%;
        top: 15px;
        bottom: 0;
        left: 50%;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 100;
        color: #FFFFFF;
        padding-left: 7%;
    }

    .access-introduce-img {
        margin-top: 40px;
        height: 250px;
    }

    .face-auth-contact-us {
        margin-top: 70px;
        position: relative;
        width: 100%;
        height: 200px;
        background: url("../../assets/img/product/contact_us_back.png") no-repeat;
        background-size:cover;
        text-align: center;
    }

    .face-auth-contact-us-prompt {
        padding-top: 40px;
        font-size: 40px;
        font-family: PingFangSCRegular;
        color: #FFFFFF;
    }
    .face-auth-contact-us-title {
        position: absolute;
        bottom: 40px;
        left: 0;
        right: 0;
        margin: 0 auto;
        background: #4183D7;
        border-radius: 8px;
        color: white;
        font-size: 25px;
        font-family: PingFangSC-Regular, PingFang SC;
        width: 150px;
        height: 55px;
        line-height: 55px;
    }

    .face-auth-process-img {
        margin-top: 40px;
        height: 400px;
    }

    .face-auth-process-subtitle {
        margin-top: 16px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404D;
        line-height: 28px;
    }

</style>